import styled from 'styled-components';

export const ModalContent = styled.div`
  position: relative;
  background: white;
  padding: 0;
`;

export const CloseIcon = styled.div`
  position: absolute;
  top: 12px;
  right: 12px;
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 50%;
  transition: background-color 0.2s ease;
  z-index: 10;
  background: rgba(255, 255, 255, 0.85);

  &:hover {
    background-color: #ffffff;
  }

  svg {
    width: 18px;
    height: 18px;
  }
`;

export const BannerWrapper = styled.div`
  width: 100%;
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 20px 24px 24px;

  @media (max-width: 480px) {
    padding: 16px;
    gap: 14px;
  }
`;

export const Divider = styled.div`
  height: 1px;
  background: #E4E6EF;
  margin: 0;
`;

export const TextBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const MainTitle = styled.h3`
  font-size: 18px;
  font-weight: 700;
  color: #181C32;
  margin: 0;
  font-family: 'Noto Sans', sans-serif;
  line-height: 1.35;

  @media (max-width: 480px) {
    font-size: 16px;
  }
`;

export const Description = styled.p`
  font-size: 13px;
  color: #5E6278;
  margin: 0;
  font-family: 'Noto Sans', sans-serif;
  line-height: 1.5;
`;

export const HighlightText = styled.span`
  color: #017858;
  font-weight: 700;
`;

export const ShareSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const ShareLabel = styled.p`
  font-size: 13px;
  font-weight: 600;
  color: #181C32;
  margin: 0;
  font-family: 'Noto Sans', sans-serif;
`;

export const LinkContainer = styled.div`
  display: flex;
  gap: 8px;

  @media (max-width: 480px) {
    flex-direction: column;
    gap: 6px;
  }
`;

export const LinkInput = styled.input`
  flex: 1;
  min-width: 0;
  padding: 10px 14px;
  border: 1px solid #E4E6EF;
  border-radius: 8px;
  font-size: 13px;
  color: #7E8299;
  background: white;
  font-family: 'Noto Sans', sans-serif;
  outline: none;
`;

export const CopyButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 10px 16px;
  background: white;
  border: 1px solid #E4E6EF;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
  color: #3F4254;
  cursor: pointer;
  transition: all 0.2s;
  font-family: 'Noto Sans', sans-serif;
  white-space: nowrap;

  &:hover {
    background: #F3F6F9;
  }
`;

export const ShareFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
`;

export const SocialButtons = styled.div`
  display: flex;
  gap: 8px;
`;

export const SocialButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 6px;
  border: 1px solid #01AB7D;
  background: white;
  color: #01AB7D;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background: ${props => props.type === 'whatsapp' ? '#E8FBF0' : '#E6F7F2'};
  }
`;

export const InfoLink = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: none;
  border: none;
  padding: 0;
  color: #01AB7D;
  font-size: 13px;
  font-weight: 600;
  font-family: 'Noto Sans', sans-serif;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;

